import React from 'react';
import { Link } from 'react-router-dom';

const PaymentError = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50">
      <div className="bg-white rounded-lg shadow-lg p-10 max-w-md text-center">
        <div className="mb-4">
          <svg className="w-16 h-16 text-red-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l2 2m-2-2l-2 2M13 5h7m-7 0a3 3 0 00-3 3v12a3 3 0 006 0V8a3 3 0 00-3-3z"></path>
          </svg>
        </div>
        <h2 className="text-2xl font-bold mb-2 text-gray-700">Payment Failed</h2>
        <p className="text-gray-500 mb-4">Oops! Something went wrong with your payment. Please try again or contact support.</p>
        <div className="mt-6">
          <Link to="/AddFunds" className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded shadow">
            Try Again
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentError;
